import { render, staticRenderFns } from "./Salary.edit.vue?vue&type=template&id=ad8bd2b2&scoped=true&"
import script from "./Salary.edit.vue?vue&type=script&lang=js&"
export * from "./Salary.edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8bd2b2",
  null
  
)

export default component.exports